import { useState, useEffect } from 'react';
import {
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalReportProblem } from '../modals/reportProblemModal';
import { ApplicationName } from "../../configs";
import { Link } from 'react-router-dom';
import {useFunctionalityChangelog } from "../../pages/hooks/functionalityChangelog"
 

export function Footer(): JSX.Element {
  const [show, setShow] = useState<boolean>(false);
  const [latestRelease, setLatestRelease] = useState<string>("");

  const { getLatestRelease } = useFunctionalityChangelog();

  useEffect(()=>{
    (async () => {
      const latest = await getLatestRelease();
      if (latest) setLatestRelease(latest);
    })();

  }, [])

  return (
    <>
      <footer className="footer ">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col">
              <p className='text-center mb-0'>
                <small>
                  &#169;  {ApplicationName}  
                  <Link to="/changelog" style={{fontSize: "10px", fontWeight: "500", color: "var(--site-purple)", marginLeft: "3px"}}>
                  {latestRelease}
                  </Link>
                  
                </small>
              </p>
            </div>
            <div className="ml-auto  width-fit-content mr-3">
              {/* <Link to="/changelog" style={{fontSize: "12px", color: "var(--site-purple)"}}>
                Changelog
              </Link> */}
            </div>
          </div>


        </div>
      </footer>
      <ModalReportProblem
        show={show}
        handleShow={setShow}
      />
    </>
  )
}